import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  private socket: Socket;

  pendingInvoiceCount: BehaviorSubject<{ pending_invoices: number }> = new BehaviorSubject<{ pending_invoices: number }>({
    pending_invoices: 0
  });

  constructor() {
    this.socket = io(environment.API_URL); // Backend URL
  }

  // Listen for events
  on(event: string): Observable<any> {
    return new Observable((observer) => {
      this.socket.on(event, (data) => {
        observer.next(data);
      });
    });
  }

  // Emit events
  emit(event: string, data: any): void {
    this.socket.emit(event, data);
  }

  // Disconnect
  disconnect(): void {
    this.socket.disconnect();
  }
}
